import React from "react";
import "./index.scss";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Button, Card } from "antd";
import WORD_ICON from "assets/images/word.png";
import PDF_ICON from "assets/images/pdf.png";
import EXCEL_ICON from "assets/images/excel.png";
import TXT_ICON from "assets/images/txt.png";
import FILE_ICON from "assets/images/file.png";
import { CloudDownloadOutlined } from "@ant-design/icons";
const { Meta } = Card;
const FileItem = (props) => {
  const { t } = useTranslation();
  return (
    <>
      <Card
        cover={
          props.file.fileName.split('.').pop() === "docx" ? (
            <img alt="" src={WORD_ICON} />
          ) : props.file.fileName.split('.').pop() === "pdf" ? (
            <img alt="" src={PDF_ICON} />
          ) : props.file.fileName.split('.').pop() === "xlsx" ? (
            <img alt="" src={EXCEL_ICON} />
          ) : props.file.fileName.split('.').pop() === "txt" ? (
            <img alt="" src={TXT_ICON} />
          ) : (
            <img alt="" src={FILE_ICON} />
          )
        }
        className="data-item-section"
      >
        <Meta title={t(props.file.title)} />
        <Button type="link" className="activite-item-section-button" href={props.file.url} >
          {t("Télécharger")}
          <CloudDownloadOutlined />
        </Button>
      </Card>
    </>
  );
};

FileItem.propTypes = {
  file: PropTypes.object,
};

export default FileItem;
